import React, { useState } from 'react';
import Navbar from '../components/Feed/FeedNavbar';
import LeftSidebar from '../components/Feed/LeftSidebar';
import RightSidebar from '../components/Feed/RightSidebar';
import MainFeed from '../components/Feed/MainFeed';
import BottomNavbar from '../utils/unifiedBottom';
import { useMediaQuery } from '../hooks/useMediaQuery';

const Trending = () => {
  const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);
  
  // Detect if screen width is at least 1280px (Tailwind xl breakpoint)
  const isDesktop = useMediaQuery('(min-width: 1280px)');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navigation */}
      <Navbar
        isRightSidebarOpen={isRightSidebarOpen}
        setIsRightSidebarOpen={setIsRightSidebarOpen}
      />

      {/* Main Layout */}
      <div className="pt-4 lg:pt-20 flex justify-center max-w-7xl mx-auto gap-4 lg:gap-4 xl:gap-6 px-4 lg:px-6">
        
        {/* Left Sidebar: Fixed at w-64, hidden on mobile screens via CSS */}
        <LeftSidebar isRightSidebarOpen={isRightSidebarOpen} />

        {/* Main Feed: 
            - lg:max-w-[650px]: Keeps the feed centered with LeftSidebar.
            - xl:max-w-none: Becomes flexible when the Right Sidebar is present.
        */}
        <div className="flex-1 min-w-0 w-full lg:max-w-[650px] xl:max-w-none">
          <MainFeed isTrending={true} />
        </div>

        {/* Right Sidebar: 
            - Logic: Only renders if isDesktop is true.
            - This ensures the useSuggestedUsers query is never called on mobile/tablet.
        */}
        {isDesktop && (
          <div className="w-80 flex-shrink-0">
            <RightSidebar isVisible={isDesktop} />
          </div>
        )}
      </div>

      {/* Bottom Navigation: Visible on mobile/tablet only */}
      <div className="lg:hidden">
        <BottomNavbar />
      </div>
    </div>
  );
};

export default Trending;